import { useManagers } from 'hooks/useManagement';
import { IManagement } from 'types/Management';

import DeleteIcon from '@mui/icons-material/Delete';
import {
  IconButton,
  Stack,
  styled,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export interface IManagementRow {
  manager: IManagement;
}

export const ManagementRow: React.FC<IManagementRow> = ({ manager }) => {
  const { deleteDialog, setManagerId } = useManagers();

  return (
    <StyledTableRow>
      <TableCell component="th" scope="row">
        {manager.name}
      </TableCell>

      <TableCell>{manager.email}</TableCell>

      <TableCell>
        {manager.isSuperUser ? 'Super usuário' : 'Usuário comum'}
      </TableCell>

      <TableCell>
        <Stack flexDirection="row" gap="8px">
          <Tooltip title="Deletar">
            <IconButton
              aria-label="edit"
              color="inherit"
              onClick={() => {
                setManagerId(manager._id);
                deleteDialog.onOpen();
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </StyledTableRow>
  );
};
